import { render, staticRenderFns } from "./echarts-pie.vue?vue&type=template&id=f2f4ae1c&scoped=true&"
import script from "./echarts-pie.vue?vue&type=script&lang=js&"
export * from "./echarts-pie.vue?vue&type=script&lang=js&"
import style0 from "./echarts-pie.vue?vue&type=style&index=0&id=f2f4ae1c&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f4ae1c",
  null
  
)

export default component.exports